module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/press/linescape-4-anniversary-transhipment-voyage/linescape-4-anniversary-transhipment-voyage.component.scss
// module id = 805
// module chunks = 0